<template>
<v-dialog id="end-tour-component" persistent fullscreen v-model="open">
  <v-card max-height="100%" color="black" class="pa-3">

    <v-toolbar flat color="#D6B682">
      <v-toolbar-title class="bebas black--text">troubleshooting</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn color="black" flat left @click="closeTSDialog">close<v-icon>close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card color="rgba(0, 0, 0, 0.9)" class="pt-3">
      <v-container pa-0 text-xs-center fill-height>
        <v-flex d-flex>
          <v-flex xs12>

            <v-flex d-flex align-center justify-center mt-3>
              <v-flex xs10>

                <p class="text-xs-center white--text fs-16">If you need to restart the tour at the beginning</p>
              </v-flex>
            </v-flex>
            <v-flex d-flex align-center justify-center>

              <v-flex xs6 d-flex>
                <v-btn class="button-border-beige" flat block color="#D6B682" @click.native="restartTour">restart tour
                  <v-icon color="#D6B682" class="ml-3">undo</v-icon>
                </v-btn>

              </v-flex>
            </v-flex>

            <v-flex d-flex align-center justify-center mt-3>
              <v-flex xs10>
                <p class="text-xs-center white--text fs-16">If you are having any serious issues with the app</p>
              </v-flex>
            </v-flex>
            <v-flex d-flex align-center justify-center>

              <v-flex xs6 d-flex>
                <v-btn class="button-border-beige" flat block color="#D6B682" @click.native="refreshApp">refresh app
                  <v-icon color="#D6B682" class="ml-3">autorenew</v-icon>
                </v-btn>

              </v-flex>
            </v-flex>

            <v-flex d-flex align-center justify-center mt-3>
              <v-flex xs10>
                <p class="text-xs-center white--text fs-16">If you need to work through the application demo again</p>
              </v-flex>
            </v-flex>

            <v-flex d-flex align-center justify-center>
              <v-flex xs6 d-flex>
                <v-btn class="button-border-beige" flat block color="#D6B682" @click.native="gotoDemo">go-to demo
                  <v-icon color="#D6B682" class="ml-3">arrow_forward</v-icon>
                </v-btn>
              </v-flex>
            </v-flex>

            <v-divider class="my-3" color="white"></v-divider>

            <v-list dark class="black">
              <v-list-group no-action dark class="black white--text">
                <v-list-tile slot="activator">
                  <v-list-tile-content>
                    <v-list-tile-title>Downloading To Your Home Screen</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-card class="black text-xs-start">
                  <v-list dark class="ts-list pa-0 ma-0 black">

                    <v-list-group no-action dark class="black white--text">
                      <v-list-tile class="ts-list-tile" slot="activator">
                        <v-list-tile-content>
                          <v-list-tile-title>Android devices</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>

                      <v-card class="prestige-font black">
                        <v-card-text>
                          <v-flex xs12 mt-3 id="android-aths-instructions">
                            <ol class="text-xs-left">
                              <li class="ma-3 text-xs-start">
                                Click the Share Button on the top left of your screen
                                <v-flex d-flex text-xs-center>
                                  <v-flex>
                                    <!-- <v-img :src="shareButtonFull" /> -->
                                  </v-flex>
                                </v-flex>
                              </li>
                              <li class="ma-3">Click the Add To Home Screen Option
                                <v-flex d-flex text-xs-center>
                                  <v-flex>
                                    <!-- <v-img :src="shareMenuFull" /> -->
                                  </v-flex>
                                </v-flex>
                              </li>
                              <li class="ma-3">Once prompted with dialog, click Add.
                                <v-flex d-flex text-xs-center>
                                  <v-flex>
                                    <!-- <v-img :src="athsFull" /> -->
                                  </v-flex>
                                </v-flex>
                              </li>
                              <li class="ma-3">Use the Icon from this point on to open the Application
                                <v-flex d-flex text-xs-center>
                                  <v-flex>
                                    <!-- <v-img :src="iconView" /> -->
                                  </v-flex>
                                </v-flex>
                              </li>
                            </ol>
                          </v-flex>

                        </v-card-text>
                      </v-card>
                    </v-list-group>
                    <v-list-group no-action dark class="black white--text">
                      <v-list-tile class="ts-list-tile" slot="activator">
                        <v-list-tile-content>
                          <v-list-tile-title>iOS / Apple devices</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>

                      <v-card class="prestige-font black text-xs-left">
                        <v-card-text>
                          <v-flex xs12 mt-3 id="android-aths-instructions ">
                            <ol>
                              <li class="ma-3 ">
                                Click the Share Button on the bottom of your screen
                                <v-flex d-flex text-xs-center>
                                  <v-flex>
                                    <v-img :src="shareButtonFull" />
                                  </v-flex>
                                </v-flex>
                              </li>
                              <li class="ma-3">Click the Add To Home Screen Option
                                <v-flex d-flex text-xs-center>
                                  <v-flex>
                                    <v-img :src="shareMenuFull" />
                                  </v-flex>
                                </v-flex>
                              </li>
                              <li class="ma-3">Click the Add Button
                                <v-flex d-flex text-xs-center>
                                  <v-flex>
                                    <v-img :src="athsFull" />
                                  </v-flex>
                                </v-flex>
                              </li>
                              <li class="ma-3">Use the Icon from this point on to open the Application
                                <v-flex d-flex text-xs-center>
                                  <v-flex>
                                    <v-img :src="iconView" />
                                  </v-flex>
                                </v-flex>
                              </li>
                            </ol>
                          </v-flex>
                        </v-card-text>
                      </v-card>
                    </v-list-group>

                  </v-list>
                </v-card>
              </v-list-group>

            </v-list>

            <v-list dark class="black">
              <v-list-group no-action dark class="black white--text">
                <v-list-tile slot="activator">
                  <v-list-tile-content>
                    <v-list-tile-title>Clearing Your Browser Cache</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-card class="bebas black justify-start align-start">

                  <v-list dark class="ts-list pa-0 ma-0 black">
                    <v-list-group no-action dark class="black white--text">
                      <v-list-tile class="ts-list-tile" slot="activator">
                        <v-list-tile-content>
                          <v-list-tile-title>Android Devices</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>

                      <v-card class="prestige-font black text-xs-start">
                        <v-card-text>Coming soon...</v-card-text>
                      </v-card>
                    </v-list-group>
                    <v-list-group no-action dark class="black white--text">
                      <v-list-tile class="ts-list-tile" slot="activator">
                        <v-list-tile-content>
                          <v-list-tile-title>iOs / Apple Devices</v-list-tile-title>

                        </v-list-tile-content>
                      </v-list-tile>

                      <v-card class="prestige-font black text-xs-left">
                        <v-card-text>
                          <v-flex xs12 mt-3 id="android-aths-instructions ">
                            <ol>
                              <li class="ma-3 ">
                                Go to your Settings Menu
                                <v-flex d-flex text-xs-center>
                                  <v-flex>
                                  </v-flex>
                                </v-flex>
                              </li>
                              <li class="ma-3">Scroll down to the Safari option
                                <v-flex d-flex text-xs-center>
                                  <v-flex>
                                  </v-flex>
                                </v-flex>
                              </li>
                              <li class="ma-3">Scroll down and hit Advanced
                                <v-flex d-flex text-xs-center>
                                  <v-flex>
                                  </v-flex>
                                </v-flex>
                              </li>
                              <li class="ma-3">Hit Website Data
                                <v-flex d-flex text-xs-center>
                                  <v-flex>
                                  </v-flex>
                                </v-flex>
                              </li>
                              <li class="ma-3">Swipe left on https://dljw6j5aitu91.cloudfront.net and then hit Delete
                                <v-flex d-flex text-xs-center>
                                  <v-flex>
                                  </v-flex>
                                </v-flex>
                              </li>
                            </ol>
                          </v-flex>
                        </v-card-text>
                      </v-card>
                    </v-list-group>
                  </v-list>
                </v-card>
              </v-list-group>

            </v-list>

          </v-flex>
        </v-flex>

      </v-container>

    </v-card>
  </v-card>

</v-dialog>
</template>

<script>
import backButton from "@/assets/buttons/back-blk.png";
import FDILogo from "@/assets/logo_login_blk.png";
import DMGLogo from "@/assets/branding/DMG_logo.png";
import athsFull from "@/assets/onboarding/add-min.png";
import shareButtonFull from "@/assets/onboarding/share-min.png";
import shareMenuFull from "@/assets/onboarding/home-min.png";
import iconView from "@/assets/onboarding/homescreen-min.png";
export default {
  name: "troubleshooting-dialog",
  props: {
    open: {
      type: Boolean
    }
  },
  data() {
    return {
      dialog: true,
      questions: [],
      backButton: backButton,
      FDILogo,
      DMGLogo,
      athsFull,
      shareButtonFull,
      shareMenuFull,
      iconView
    };
  },
  methods: {
    closeTSDialog() {
      this.$store.dispatch("closeTSDialog");
    },
    refreshApp() {
      this.$router.replace("/", res => {
        window.location.reload();
      });
    },

    restartTour() {
      this.$store.dispatch("restartTour").then(() => {
        this.$router.push("/tour");
      });
    },
    gotoDemo() {
      this.$router.push("/app-demo");
    }
  },
  computed: {
    creditsDialog() {
      return this.$store.getters.creditsDialog;
    }
  }
};
</script>

<style>
#end-tour-component {
  width: 100%;
}

.ts-list .ts-list-tile .v-list__tile {
  padding-left: 25px !important;
}
</style>
